import { Panel, Stack } from 'rsuite';
import 'Components/Common/detail.css'

const isDarkSchemePrefered = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
export const Card = (props) => (
  <Panel
    header={
      <Stack justifyContent="space-between">
        <span>{props.header}</span>
      </Stack>
    }
    shaded
    bordered
    style={{ minHeight: 655, maxHeight: 655, overflowY: 'auto', background: isDarkSchemePrefered ? '#212124' : '' }}
  >
    {props.children}
  </Panel>
);
